export default __webpack_public_path__ + "static/media/2.525d05b9.jpg";